import { AxiosRequestConfig } from 'axios'
import {
  RoadmapEvent as Data,
  RoadmapEventCollection as Collection,
} from '@/typings/api/RoadmapEvent'
import { File as FileData } from '@/typings/api/File'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class RoadmapEventsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'publications/events';

  public getParents(eventId: Data['id'], config?: AxiosRequestConfig) {
    const path = ':event_id/parents/'
    const options = { event_id: eventId }
    const [url] = this.getUrl(path, options)
    return this.request('GET', url, config)
  }

  public updateConfirmed(data: Record<string, unknown>, config?: AxiosRequestConfig) {
    const path = 'update-confirmed/'
    const [url] = this.getUrl(path, data)
    return this.request('POST', url, { data, ...config })
  }

  public uploadFile(eventId: Data['id'], file: File, config?: AxiosRequestConfig) {
    const path = ':event_id/files/upload/'
    const [url] = this.getUrl(path, { event_id: eventId })
    const data = new FormData()
    data.append('file', file)
    return this.request('POST', url, { data, ...config })
  }

  public deleteFile(
    eventId: Data['id'],
    fileId: FileData['id'],
    config?: AxiosRequestConfig,
  ) {
    const path = ':event_id/files/:file_id/delete'
    const options = { event_id: eventId, file_id: fileId }
    const [url] = this.getUrl(path, options)
    return this.request('POST', url, { ...config })
  }

  public updateStatus(
    eventId: Data['id'],
    status: string,
    config?: AxiosRequestConfig,
  ) {
    const path = ':event_id/update/status/'
    const options = { event_id: eventId }
    const data = { status }
    const [url] = this.getUrl(path, options)
    return this.request('POST', url, { data, ...config })
  }

  public updateCuratorStatus(
    eventId: Data['id'],
    status: string,
    config?: AxiosRequestConfig,
  ) {
    const path = ':event_id/update/curator-status/'
    const options = { event_id: eventId }
    const data = { status }
    const [url] = this.getUrl(path, options)
    return this.request('POST', url, { data, ...config })
  }

  public getHistory(
    eventId: Data['id'],
    params: Record<string, unknown> = {},
    config?: AxiosRequestConfig,
  ) {
    const path = ':event_id/history/'
    const options = { event_id: eventId }
    const [url] = this.getUrl(path, options)
    return this.request('GET', url, { params, ...config })
  }

  public read(
    eventId: Data['id'],
    params: Record<string, unknown> = {},
    config?: AxiosRequestConfig,
  ) {
    const path = ':event_id/read/'
    const options = { event_id: eventId }
    const [url] = this.getUrl(path, options)
    return this.request('POST', url, { params, ...config })
  }
}
